var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.03 96.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m47.65,96.03h48.38s0-48.38,0-48.38c0-26.31-21.33-47.65-47.65-47.65H0v48.38c0,26.31,21.33,47.65,47.65,47.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--iconBgColor)",
    d: "m30.36,73.74c0-9.73,7.92-17.65,17.65-17.65,9.73,0,17.65,7.92,17.65,17.65h11.24c0-15.93-12.96-28.89-28.89-28.89-15.93,0-28.89,12.96-28.89,28.89h11.24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--iconBgColor)",
    d: "m65.67,27.11c0,9.73-7.92,17.65-17.65,17.65-9.73,0-17.65-7.92-17.65-17.65h-11.24c0,15.93,12.96,28.89,28.89,28.89,15.93,0,28.89-12.96,28.89-28.89h-11.24Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "var(--iconBgColor)",
    cx: 48.01,
    cy: 27.11,
    r: 8.83
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.5be907e2b89bc6ea6e5f242ee0190f66.svg";
export { ForwardRef as ReactComponent };